export default "__VITE_ASSET__71e0ca46__"